



































































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import axios from 'axios';
import VueToastr from '@deveodk/vue-toastr';
import { ChangePasswordRequest } from '../models/userdata/changepasswordrequest';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'ChangePassword',
  components: {},
})
export default class ChangePassword extends Vue {
  private request = new ChangePasswordRequest();
  $wlToastr: any;

  private errorString: string = '';
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  async changePassword() {
    if (!this.validateChangePasswordData(this.request)) {
      this.$wlToastr('error', this.$t(this.errorString), this.$t('profile-accordion.change_password'));
    } else {
      const bearerToken = 'Bearer ' + vxm.users.getToken;
      console.log('Change password');
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/changePassword',
        this.request,
        {
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      console.log(resp);

      if (resp.data.success) {
        this.$wlToastr('success', resp.data.successMessage, this.$t('profile-accordion.change_password'));
        await vxm.users.logout();
        console.log(vxm.users.isLoggedIn);
        this.$router.push({ name: 'Login' });
      } else {
        this.$wlToastr('error', resp.data.errorMessage, this.$t('profile-accordion.change_password'));
      }
    }
  }

  validateChangePasswordData(
    changePasswordRequestr: ChangePasswordRequest,
  ): boolean {
    if (!changePasswordRequestr.oldPassword) {
      this.errorString = 'changepassword.current.password.required';
      return false;
    }

    if (!changePasswordRequestr.newPassword) {
      this.errorString = 'changepassword.new.password.required';
      return false;
    }

    if (!changePasswordRequestr.confirmPassword) {
      this.errorString = 'changepassword.confirn.password.required';
      return false;
    }

    return true;
  }
}
